/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button, Divider, Grid, LinearProgress, Tab, Tabs, Typography } from '@mui/material';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { CardRise, FilesTable, HistoicRise, ToolsDamInformation } from '../../../components/custom';
import { CustomAlert, VMenu } from '../../../components/shared';
import { LayoutBase } from '../../../layouts';
import { IReportsRise, ReportsServicesRise } from '../../../services/api/reports/ReportsServicesRise';
import { FileServicesBack, IFileServices } from '../../../services/api/files/FileServicesBack';
import { Add } from '@mui/icons-material';
import { useAuthContext } from '../../../context';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export const Rise = () => {
  const url = useParams();
  const [value, setValue] = React.useState(0);
  const navigate = useNavigate();
  const [loadin, setLoadin] = useState<boolean>(false);

  const { userData } = useAuthContext();
  // const permissions = userData.permissoes;

  //Rise
  const [data, setData] = useState<IReportsRise[]>([]);
  const [lastRise, setLastRise] = useState<IReportsRise>();

  //Files
  const [dataFilter, setDataFilter] = useState<IFileServices[]>([]);
  const [dataFiles, setDataFiles] = useState<IFileServices[]>([]);
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');

  const [isDialogOpen, setDialogOpen] = useState(false);
  const [alertInfo, setAlertInfo] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'warning' | 'info' }>({
    open: false,
    message: '',
    severity: 'success'
  });

  const risePermissionsString: string | undefined = useMemo(() => {
    return userData?.nivel_acesso?.registros?.RISE;
  }, [userData]);

  const hasRisePermission = useCallback((action: 'add' | 'edit' | 'remove' | 'view'): boolean => {
    if (typeof risePermissionsString === 'string' && risePermissionsString !== '') {
      return risePermissionsString.includes(action);
    }
    return false;
  }, [risePermissionsString]);

  useEffect(() => {
    setLoadin(true);
    fetheData();
    fetchDataFiles();
  }, []);

  //Funcoes de arquivos
  const fetchDataFiles = () => {
    if (url.id) {
      FileServicesBack.get(url.id)
        .then((result) => {
          if (result instanceof Error) {
            setAlertInfo({ open: true, message: `Erro ao buscar arquivos! error: ${result.message}`, severity: 'info' });
          } else {
            const filter = result.filter(index => index.tipo.tipo === 'Relat\u00f3rio de Inspe\u00e7\u00e3o de Seguran\u00e7a Especial' && index.status == true);
            // console.log('filtro', filter);

            setDataFiles(filter);
          }
        });
    }
  };

  const showAlert = (message: string, severity: 'success' | 'error' | 'warning' | 'info') => {
    setAlertInfo({ open: false, message: '', severity: 'info' });
    setTimeout(() => {
      setAlertInfo({ open: true, message, severity });
    }, 100);
  };

  async function handleDeleteFile(valueId: string | undefined) {
    if (valueId !== undefined) {
      FileServicesBack.deleteById(valueId)
        .then((result) => {
          if (result instanceof Error) {
            showAlert('Não foi possível excluir o documento! ' + result.message, 'error');
          } else {
            showAlert('Documento excluído!', 'success');
            fetchDataFiles();
            setDialogOpen(false);
          }
        });
    }
  }

  function handleFileType(newValue: string[] | null) {
    if (newValue !== null) {
      if (newValue.length > 0) {
        if (dataFilter) {
          const filteredData = dataFilter.filter(index => {
            const tipo = index.tipo?.tipo || '';
            const normalizedTipo = tipo.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
            return newValue.some(value => {
              const normalizedValue = value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
              return normalizedTipo.includes(normalizedValue);
            });
          });
          setDataFilter(filteredData);
        }
      } else {
        setDataFilter(dataFiles);
      }
    } else {
      setDataFilter(dataFiles);
    }
  }

  async function sortedData() {
    if (dataFilter) {
      const sorted = dataFilter.slice().sort((a, b) => {
        if (a.data_emissao && b.data_emissao) {
          const dateA = new Date(a.data_emissao).getTime();
          const dateB = new Date(b.data_emissao).getTime();
          if (sortDirection === 'asc') {
            setSortDirection('desc');
            return dateA - dateB;
          } else {
            setSortDirection('asc');
            return dateB - dateA;
          }
        }
        return 0;
      });
      setDataFilter(sorted);
    }
  }

  const toggleDialog = () => {
    setDialogOpen(!isDialogOpen);
  };

  function handleEditFile(key: string | undefined) {
    if (key !== undefined) {
      navigate(`/information_dam/${url.dam}/files/file/${key}`);
    }
  }

  // Fucoes RISE
  const fetheData = () => {
    if (url && url.id) {
      ReportsServicesRise.getAll(url.id)
        .then((result) => {
          if (result instanceof Error) {
            console.log(result.message);
            setLoadin(false);
            showAlert('Error ao buscar dados ' + result.message, 'error');
          } else {
            setData(result);
            const lastValue = getLastRise(result);
            if (lastValue !== null) {
              setLastRise(lastValue);
              setLoadin(false);

            }
          }
        });
    }
    setLoadin(false);
  };


  function getLastRise(values: IReportsRise[]): IReportsRise | null {
    if (values.length === 0) return null;

    // Filtrar valores que têm data_criacao definida e válida
    const validValues = values.filter(item => item.data_criacao !== undefined && item.data_criacao !== null);

    if (validValues.length === 0) return null;

    // Encontra o objeto com a data_criacao mais recente
    const newest = validValues.reduce((prev, current) => {
      const prevDate = new Date(prev.data_criacao!);
      const currentDate = new Date(current.data_criacao!);
      return prevDate > currentDate ? prev : current;
    });

    return newest;
  }

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <LayoutBase
      title='Relatório Inspeção de Segurança Especial (RISE)'
      tollBar={<ToolsDamInformation />}

    >
      <Box width={'100%'}>
        <VMenu id={url.id} />
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }} justifyContent={'space-around'} display={'flex'}>
          <Tabs value={value} onChange={handleChange} variant="scrollable" scrollButtons allowScrollButtonsMobile>
            <Tab label="RESUMO EXECUTIVO" {...a11yProps(0)} />
            <Tab label="HISTORICO" {...a11yProps(1)} />
            {/* <Tab label="ARQUIVOS" {...a11yProps(2)} /> */}
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <Box width={'100%'} gap={2} display={'flex'} flexDirection={'column'} padding={1}>
            <Box width={'100%'} padding={1} >
              <Grid container alignItems="center" justifyContent="space-between">
                <Grid item xs={12} sm={9} md={10}>
                  <Typography variant='h5'>Último resumo executivo</Typography>
                </Grid>
                <Grid item xs={1}>
                  {!url.rise && hasRisePermission('add') ? (
                    <Button startIcon={<Add />} sx={{ borderRadius: '25px' }} variant='outlined' color='primary' onClick={() => navigate('./new')}>
                      Novo
                    </Button>
                  ) : null}
                </Grid>
                <Grid item xs={12} marginTop={1}>
                  <Divider />
                </Grid>
              </Grid>
            </Box>
          </Box>
          <Box width={'100%'}>
            {/* {lastRise !== undefined ? <CardRise data={lastRise} /> : <Loadin/>} */}
            {loadin ? (
              <LinearProgress />
            ) : (
              lastRise ? (
                <CardRise data={lastRise} />
              ) : null
            )}
          </Box>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <HistoicRise
            data={data}
            hasViewPermission={hasRisePermission('view')}
          />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <FilesTable
            dataFilter={dataFiles}
            handleDelete={handleDeleteFile}
            handleFileType={handleFileType}
            sortedData={sortedData}
            url={url}
            title='Arquivos Rise'
            isDialogOpen={isDialogOpen}
            toggleDialog={toggleDialog}
            handleEditFile={handleEditFile}
            type='rise'
            showAdd={hasRisePermission('add')}
            pagePermissions={risePermissionsString}
          />
        </CustomTabPanel>
      </Box>
      {alertInfo.open &&
        <CustomAlert
          message={alertInfo.message}
          severity={alertInfo.severity}
        />
      }
    </LayoutBase>
  );
};